import { z } from "zod";
import { PORTAL_FAMILY_HOST_LABELS } from "../constants/portal-hosting.js";
/**
 * Tenant registry — staff-only schema describing the list of all
 * tenants the operator can act against (e.g. for the cross-tenant
 * portal-user switcher). Returns slugs plus non-sensitive portal-family
 * routing metadata — no tenant business data leaks through this endpoint.
 *
 * Canon: docs/design-canon/04-shared/ssot.md.
 */
export const TenantSummarySchema = z.object({
    /** Tenant schema slug (e.g. `gop`, `l30`). Lowercase, kebab-case. */
    slug: z
        .string()
        .min(1)
        .max(64)
        .regex(/^[a-z0-9-]+$/),
    /** Family host selected from persisted metadata or the safe fallback map. */
    portalFamily: z.enum(PORTAL_FAMILY_HOST_LABELS).optional(),
});
export const TenantListResponseSchema = z.object({
    tenants: z.array(TenantSummarySchema),
});
//# sourceMappingURL=tenants.js.map